export const DAYS = [
  { id: 0, key: 'sunday', name: 'ראשון' },
  { id: 1, key: 'monday', name: 'שני' },
  { id: 2, key: 'tuesday', name: 'שלישי' },
  { id: 3, key: 'wednesday', name: 'רביעי' },
  { id: 4, key: 'thursday', name: 'חמישי' },
  { id: 5, key: 'friday', name: 'שישי' },
  { id: 6, key: 'saturday', name: 'שבת' }
] as const;

export const DEFAULT_BREAK = {
  start_time: '12:00',
  end_time: '13:00'
} as const;

export const DEFAULT_SPECIAL_DATE = {
  date: new Date().toISOString().split('T')[0],
  is_closed: false,
  start_time: '09:00',
  end_time: '17:00',
  note: ''
} as const;